import { render, staticRenderFns } from "./AnaliseProduto3FatGrupoProdutosClassificacao.vue?vue&type=template&id=e2524582&scoped=true&"
import script from "./AnaliseProduto3FatGrupoProdutosClassificacao.vue?vue&type=script&lang=js&"
export * from "./AnaliseProduto3FatGrupoProdutosClassificacao.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseProduto3FatGrupoProdutosClassificacao.vue?vue&type=style&index=0&id=e2524582&scoped=true&lang=css&"
import style1 from "./AnaliseProduto3FatGrupoProdutosClassificacao.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2524582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
